/**
 * District-driven auto-population for the wholesale signup form
 * (shopify-forms-embed, an open-shadow-DOM third-party app block — no theme
 * template controls its fields, so this works by observing and writing to
 * its rendered DOM directly).
 *
 * On district selection: Postal Code, Provincia, and País are filled from
 * window.LIMA_DISTRICTS (assets/lima-districts.js) and locked read-only.
 * Province is always "Lima", country is always "Perú", by construction of
 * that dataset — there is no code path here that could produce anything
 * else for a Lima district list.
 */

(function () {
  const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;

  function setFieldValue(input, value) {
    if (!input) return;
    nativeInputValueSetter.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function applyDistrict(root, districtName) {
    const match = window.LIMA_DISTRICTS.find((d) => d.district === districtName);
    if (!match) return;

    const postal = root.querySelector('[data-testid="field-custom#codigo_postal"]');
    const provincia = root.querySelector('[data-testid="field-custom#provincia"]');
    const pais = root.querySelector('[data-testid="field-custom#pas"]');

    setFieldValue(postal, match.postal_code);
    setFieldValue(provincia, match.province);
    setFieldValue(pais, match.country);

    [postal, provincia, pais].forEach((field) => {
      if (field) field.readOnly = true;
    });
  }

  function wireForm(root) {
    if (root.__districtAutofillWired) return;
    root.__districtAutofillWired = true;

    // Capture phase: intercepts the click before the app's own bubble-phase
    // handler can call stopPropagation() on it.
    root.addEventListener(
      'click',
      (event) => {
        const option = event.target.closest('[role="option"]');
        if (!option) return;

        // Let the app's own selection handler still run (it owns the
        // dropdown's open/close and selected state), then read the result.
        setTimeout(() => applyDistrict(root, option.textContent.trim()), 50);
      },
      true
    );
  }

  // The form is a custom element (shopify-forms-embed) that attaches its
  // shadow root and populates its fields asynchronously after being added to
  // the page, with no event to signal "ready" — so poll briefly instead of
  // relying solely on a MutationObserver, which can miss shadow-root-internal
  // changes entirely.
  function scanForForms() {
    document.querySelectorAll('shopify-forms-embed').forEach((host) => {
      if (host.shadowRoot && host.shadowRoot.querySelector('[id*="distrito"]')) {
        wireForm(host.shadowRoot);
      }
    });
  }

  const pollInterval = setInterval(scanForForms, 300);
  setTimeout(() => clearInterval(pollInterval), 20000);
  scanForForms();
})();
